import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Logo from 'components/logo';
import { getUrl } from '@/utils/utils.jsx';

export default function PluginUnauthorized({ onRetry, reason }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginRedirect = () => {
    navigate(getUrl(location.pathname, 'login'));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static" sx={{ bgcolor: 'background.paper', boxShadow: 'none' }}>
        <Toolbar>
          <Logo />
        </Toolbar>
      </AppBar>

      <Stack
        spacing={2}
        sx={{ flex: 1, alignItems: 'center', justifyContent: 'center', textAlign: 'center', px: 2 }}
      >
        <Typography variant="h4">You don't have permission to access this content</Typography>
        {reason && (
          <Typography variant="body2" color="text.secondary">
            Reason: {reason}
          </Typography>
        )}
        <Stack direction="row" spacing={2}>
          {onRetry && (
            <Button variant="outlined" onClick={onRetry}>
              Retry
            </Button>
          )}
          <Button variant="contained" onClick={handleLoginRedirect}>
            Go to login
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

PluginUnauthorized.propTypes = { onRetry: PropTypes.func, reason: PropTypes.string };
